import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  isManuallyExpanded?: boolean
  anyManuallyExpanded?: boolean
  onToggle?: () => void
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  isManuallyExpanded = false,
  anyManuallyExpanded = false,
  onToggle,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config

  // The active (current route) module always stays open, even when the user
  // manually expands another module. Non-active modules open only when the
  // user explicitly expands them.
  const isOpen = isActive || isManuallyExpanded

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault()
    onToggle?.()
  }

  return (
    <div
      className={clsx('menu-item custom-responsive-font', {'here show': isOpen}, 'menu-accordion')}
    >
      <span className='menu-link ' onClick={handleToggle} style={{cursor: 'pointer'}}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isOpen})}>
        {children}
      </div>
    </div>
  )
}

export {SidebarMenuItemWithSub}
